import { classes } from "lib/actions/util";
import { PropsWithChildren } from "react";
import { Tab } from "@headlessui/react";
import { LayoutGroup } from "motion/react";
import { twMerge } from "tailwind-merge";

export default function SliderTabBar(
  p: PropsWithChildren<{
    /** Required for layout animation where multiple instances of
     * this component are rending on the same page.
     */
    layoutGroupId: string;
    className?: { root?: string; bg?: string };
  }>,
) {
  return (
    <Tab.List
      as="div"
      className={twMerge(
        classes(
          "flex overflow-clip rounded-md p-1.5",
          "text-center text-neutral-600 transition-colors duration-500",
          "bg-neutral-100",
        ),
        p.className?.bg,
        p.className?.root,
      )}
    >
      <LayoutGroup id={p.layoutGroupId}>{p.children}</LayoutGroup>
    </Tab.List>
  );
}
